/**
 * @module mediadownload
 */
class mediadownload {

  /**
   * @param {HTMLElement} element - The HTMLElement this module is constructed upon
   * @param {Object} options - ConditionerJS's merged options
   */
    constructor(element, options) {
        this._element = element;
        this._options = Object.assign(mediadownload.options, options);
        this._mediaId = element.dataset.options;
        this._downloadMedia = this._downloadMedia.bind(this);
        this.load();
    }


  /**
   * Base options
   */
    static get options() {
        return {
            mediaId: null
        };
    }


  /**
   * Construct module
   */
    load() {
        window.addEventListener('click', this._downloadMedia);
    }

  /**
   * Click event handler
   * @private
   */
    _downloadMedia() {
        let ObjItemId = JSON.parse(this._mediaId);
        let datapost = { ItemId: ObjItemId.mediaId };
        let url = `${window.location.protocol}//${window.location.hostname}/api/Sitecore/DownloadMedia/Pdf`;
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(datapost),
            headers: {
                'Content-Type': 'application/json'
            }
        })
      .then(response => {
          if (response.ok) {
              return Promise.resolve(response);
          }

          return Promise.reject(new Error('Failed to load'));

      })
      .then(response => response.json())
      .then(data => {
          this._download(data.Url, data.filename);
      })
      .catch(error => {
          return Promise.reject(new Error(error.message));
      });
    }

  /**
       * File Download Handler
       * @param {string} url - Media Url Path
       * @param {string} filename - Media Name
       * @private
       */
    _download(url, filename) {
        fetch(url).then(t => {
            return t.blob().then(b => {
                let a = document.createElement('a');
                a.href = URL.createObjectURL(b);
                a.setAttribute('download', filename);
                a.click();
            }
      );
        });
    }
}
export default mediadownload;
